/* CasualOS is a set of web-based tools designed to facilitate the creation of real-time, multi-user, context-aware interactive experiences.
 *
 * Copyright (c) 2019-2025 Casual Simulation, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { AuxBot3DDecoratorBase } from '../AuxBot3DDecorator';
import type { AuxBot3D } from '../AuxBot3D';
import type { BotCalculationContext } from '@casual-simulation/aux-common';

import { calculateScale } from '../SceneUtils';

export class ScaleDecorator extends AuxBot3DDecoratorBase {
    constructor(bot3D: AuxBot3D) {
        super(bot3D);
    }

    botUpdated(calc: BotCalculationContext): void {
        const gridScale = this.bot3D.gridScale;

        const scale = calculateScale(calc, this.bot3D.bot, gridScale);
        this.bot3D.scaleContainer.scale.set(scale.x, scale.y, scale.z);

        // Update all the bots that have this set as their transformer.
        const matches = calc.lookup.query(
            calc,
            ['transformer'],
            [this.bot3D.bot.id]
        );
        this.bot3D.dimensionGroup.simulation3D.ensureUpdate(
            matches.map((b) => b.id)
        );
    }

    dispose(): void {}
}
